import { useTheme } from "@mui/system";

// Иконка раздела "Dianapp": снимок исследования с рамкой кадрирования и лупой.
// Стиль тот же, что у остальных medCardPageIcons - плоский svg, цвет из
// theme.palette.rgd.primary.
export default function DianappIcon({ size = 40 }) {
  const theme = useTheme();

  const baseWidth = 40;
  const baseHeight = 40;

  // Иконка квадратная, поэтому масштабируется по size целиком (в SectionCard она
  // растягивается до ширины контейнера, в списке уведомлений вызывается с size={20})
  const height = (baseHeight * size) / baseWidth;

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Рамка снимка */}
      <path
        d="M4 2H36C37.1046 2 38 2.89543 38 4V27C38 28.1046 37.1046 29 36 29H4C2.89543 29 2 28.1046 2 27V4C2 2.89543 2.89543 2 4 2ZM4.5 4.5V26.5H35.5V4.5H4.5Z"
        fill={theme.palette.rgd.primary}
      />

      {/* Уголки кадрирования */}
      <path
        d="M7 7H13V9.2H9.2V13H7V7ZM27 7H33V13H30.8V9.2H27V7ZM7 18H9.2V21.8H13V24H7V18ZM30.8 18H33V24H27V21.8H30.8V18Z"
        fill={theme.palette.rgd.primary}
      />

      {/* Лупа - "исследование" */}
      <path
        d="M19.6 11.5C22.5823 11.5 25 13.9177 25 16.9C25 18.0301 24.6527 19.0791 24.0592 19.9463L27.6713 23.5584C28.1106 23.9977 28.1106 24.7099 27.6713 25.1492C27.232 25.5885 26.5198 25.5885 26.0805 25.1492L22.4684 21.5371C21.6012 22.1306 20.5522 22.478 19.4221 22.478C16.4398 22.478 14.0221 20.0603 14.0221 17.078C14.0221 14.0957 16.4398 11.6779 19.4221 11.6779L19.6 11.5ZM19.5 13.85C17.7603 13.85 16.35 15.2603 16.35 17C16.35 18.7397 17.7603 20.15 19.5 20.15C21.2397 20.15 22.65 18.7397 22.65 17C22.65 15.2603 21.2397 13.85 19.5 13.85Z"
        fill={theme.palette.rgd.primary}
      />

      {/* Подставка */}
      <path
        d="M13 35.8H27C27.6627 35.8 28.2 36.3373 28.2 37C28.2 37.6627 27.6627 38.2 27 38.2H13C12.3373 38.2 11.8 37.6627 11.8 37C11.8 36.3373 12.3373 35.8 13 35.8ZM18.8 31H21.2V34.6H18.8V31Z"
        fill={theme.palette.rgd.primary}
      />
    </svg>
  );
}
